//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loading from './components/common/loading'

export default {
  name: 'app',
  components: {
    loading,
  },
  computed: {
    show () {
      return this.$store.state.base.loading
    },
    mask () {
      return this.$store.state.base.mask
    },
  },
  mounted () {
    this.changeRootFont()
    window.addEventListener('resize', this.changeRootFont, false)
  },
  methods: {
    changeRootFont () {
      var html = document.documentElement
      window.windowWidth = Math.min(750, html.clientWidth)
      var size = (window.windowWidth / 3.75)
      console.log(size, 'zaa77777')
      html.style.fontSize = size + 'px'
      window.fontSize = size

      // html.style.fontSize ='100px';
      // console.log(html.style.fontSize);
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue